var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaya(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 195.85 59.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#121b12;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.85,5.62v53.66h-9.24V5.62H3.29l-3.29.69V0l3.29.69h39.88l3.29-.69v6.31l-3.29-.69h-15.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.55,33.34v25.95h-9.24v-25.18L95.33.08h10.67l17.11,27.72L140.15.08h5.87l-20.48,33.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.83 59.28 73.75 2.58 75 .08 68.62 .08 45.71 59.28 50.87 59.28 68.65 13.44 86.02 59.28 95.83 59.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "195.85 59.28 173.77 2.58 175.02 .08 168.65 .08 145.73 59.28 150.89 59.28 168.67 13.44 186.04 59.28 195.85 59.28"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaya);
export default __webpack_public_path__ + "static/media/taya.b77347de3da3f62625e4189000db129d.svg";
export { ForwardRef as ReactComponent };